module.exports = __webpack_public_path__ + "static/image/logo-family/new_logo_commerce.ver2_0_2.png?1ee0b9cf";